import { produce } from "immer";
import { isTyduxDevelopmentModeEnabled } from "./development";
import { createFailingProxy, failIfInstanceMembersExistExceptStateOrMethods, failIfNotUndefined } from "./utils";
export function createReducerFromCommandsInvoker(facadeId, commandsInvoker) {
    var typePrefix = "[".concat(facadeId, "] ");
    return function (state, action) {
        // check if this action is for this facade
        if (action.type.indexOf(typePrefix) !== 0) {
            return state;
        }
        var commandName = action.type.substr(typePrefix.length);
        return produce(state, function (draft) { return commandsInvoker.invoke(draft, function (commands) {
            var mutatorFn = commands[commandName];
            if (mutatorFn === undefined) {
                return;
            }
            var result = mutatorFn.apply(commands, action.payload);
            failIfNotUndefined(result);
            failIfInstanceMembersExistExceptStateOrMethods(commands);
        }); });
    };
}
var CommandsInvoker = /** @class */ (function () {
    function CommandsInvoker(commands) {
        this.commands = commands;
        failIfInstanceMembersExistExceptStateOrMethods(this.commands);
    }
    CommandsInvoker.prototype.invoke = function (state, withStateOp) {
        this.commands.state = state;
        var postState;
        var mutatorThisProxy = { state: state };
        try {
            Object.setPrototypeOf(mutatorThisProxy, this.commands);
            withStateOp(mutatorThisProxy);
            postState = mutatorThisProxy.state;
            delete mutatorThisProxy.state;
            failIfInstanceMembersExistExceptStateOrMethods(mutatorThisProxy);
        }
        finally {
            if (isTyduxDevelopmentModeEnabled()) {
                Object.setPrototypeOf(mutatorThisProxy, createFailingProxy());
            }
        }
        return postState;
    };
    return CommandsInvoker;
}());
export { CommandsInvoker };
var Commands = /** @class */ (function () {
    function Commands() {
        this.state = undefined;
    }
    return Commands;
}());
export { Commands };
